import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboConnectionPoolingCandidatesResponse } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.listConnectionPoolingCandidates;

const DBO_CONNECTION_POOLING_CANDIDATES_QUERY_KEY =
  'dbo-connection-pooling-candidates';

const getConnectionPoolingCandidatesQueryKey = (
  params: Parameters<typeof apiFn>[0]
) => {
  return [DBO_CONNECTION_POOLING_CANDIDATES_QUERY_KEY, params] as const;
};

export const useConnectionPoolingCandidatesQuery = <
  TSelected = DboConnectionPoolingCandidatesResponse
>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<DboConnectionPoolingCandidatesResponse, TSelected>
) =>
  useQuery(
    queryOptions({
      queryKey: getConnectionPoolingCandidatesQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      placeholderData: keepPreviousData,
      ...options,
    })
  );
